<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <step-form-heading v-if="!props.campaignId" :icon="faFlagSwallowtail">
            New Campaign

            <template v-slot:description>
                Create blast and evergreen campaigns.
            </template>
        </step-form-heading>

        <page-header v-if="props.campaignId" class="mb-6 lg:mb-12">
            <template v-slot:subtitle>
                <router-link :to="{ name: 'campaigns', query: route.query }"
                   class="no-underline! text-sky-600! text-base font-normal">
                    <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Campaigns
                </router-link>
            </template>

            <slot name="header">{{ campaign.name }}</slot>
        </page-header>

        <div :class="{'grid grid-cols-12': props.campaignId}">
            <page-sidebar v-if="props.campaignId" :links="sidebarLinks"></page-sidebar>
            <router-view></router-view>
        </div>
    </form-container>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft, faFlagSwallowtail } from '@fortawesome/pro-solid-svg-icons';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import FormContainer from '~/components/general/FormContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { useCampaignDetails } from './useCampaignDetails';

const props = defineProps({
    campaignId: {
        type: Number,
        required: false,
    },
});

const route = useRoute();
const { campaign, loading, mount } = useCampaignDetails();

onMounted(() => {
    mount(props.campaignId);
});

const sidebarLinks = computed(() => [
    {
        to: { name: 'campaigns.edit', params: { id: props.campaignId } },
        label: 'Details',
    },
    {
        to: { name: 'campaigns.contacts', params: { id: props.campaignId } },
        label: 'Contacts',
    },
]);
</script>
